<div class="layout-topbar">
    <div class="layout-topbar-wrapper">
        <div class="layout-topbar-left">
            <div
                class="layout-topbar-logo"
                id="logolink"
                style="cursor: pointer; outline: none; margin:auto;"
                (click)="goToHome()"
            >
                <img
                    id="app-logo"
                    [src]="
                        'assets/layout/images/logo-' + (app.topbarTheme === 'light' ? 'poseidon' : 'poseidon-dark') + '.png'
                    "
                    alt="poseidon-layout"
                />
            </div>

            <!-- <a
                class="menu-button"
                href="#"
                (click)="appMain.onMenuButtonClick($event)"
            >
                <i class="pi pi-bars"></i>
            </a> -->
        </div>

        <div class="layout-topbar-right">
            <div class="router-container">
                <ng-container *ngIf="navLinks$ | async as navLinks">
                    <ng-container *ngFor="let link of navLinks">
                        <a
                            *ngIf="link.routerLink; else childrens"
                            [routerLink]="link.routerLink"
                            [routerLinkActiveOptions]="{exact: true}"
                            routerLinkActive="router-link--active"
                            class="router-link"
                        >
                            <i
                                *ngIf="link.icon"
                                [class]="link.icon"
                                style="font-size: 1.5rem;"
                            ></i>
                            {{ link.label }}
                            </a>

                            <ng-template #childrens>
                                <span
                                    routerLinkActive="router-link--active"
                                    class="router-link"
                                    (click)="menu.toggle($event)"
                                >
                                    <i
                                        *ngIf="link.icon"
                                        [class]="link.icon"
                                        style="font-size: 1.5rem;"
                                    ></i>
                                    {{ link.label }}
                                    <i
                                        class="pi pi-angle-down"
                                        style="font-size: 1.5rem;"
                                    ></i>
                                    </span>
                                    <p-menu
                                        #menu
                                        [popup]="true"
                                        [model]="link.items"
                                    ></p-menu>
                                    </ng-template>
                    </ng-container>
                </ng-container>
            </div>
            <!-- <a
                class="menu-button"
                href="#"
                (click)="appMain.onMenuButtonClick($event)"
            >
                <i class="pi pi-bars"></i>
            </a> -->

            <ul class="layout-topbar-actions">
                <!-- <li #searchItem class="search-item topbar-item" [ngClass]="{ 'active-topmenuitem': appMain.search }">
                    <a href="#" (click)="appMain.onTopbarItemClick($event, searchItem)">
                        <span class="topbar-icon">
                            <i class="pi pi-search"></i>
                        </span>
                    </a>

                    <div class="search-input-wrapper"></div>

                    <ul class="fadeInDown">
                        <div class="search-input-wrapper p-fluid"></div>
                    </ul>
                </li>
               -->

                <li
                    #profile
                    class="topbar-item user-profile"
                    [ngClass]="{ 'active-topmenuitem': appMain.activeTopbarItem === profile }"
                >
                    <a
                        href="#"
                        class="profile-container"
                        (click)="appMain.onTopbarItemClick($event, profile)"
                    >
                        <img
                            class="profile-image"
                            src="assets/layout/images/avatar-profile-new.png"
                            alt="demo"
                        />
                        <div class="profile-info">
                            <h6>{{usuario.userName}}</h6>
                            <span>{{usuario.rol}}</span>
                        </div>
                    </a>

                    <ul class="fadeInDown layout-submenu">
                        <li class="layout-submenu-header">
                            <img
                                class="profile-image"
                                src="assets/layout/images/avatar-profile-new.png"
                                alt="demo"
                            />
                            <div class="profile-info">
                                <h6>{{usuario.userName}}</h6>
                                <span>{{usuario.rol}}</span>
                            </div>
                        </li>
                        <li
                            role="menuitem"
                            class="layout-submenu-item"
                        >
                            <a (click)="misDatos()">
                                <i class="pi pi-cog"></i>
                                <h6>Configuración</h6>
                            </a>
                        </li>
                        <li
                            role="menuitem"
                            class="layout-submenu-item"
                        >
                            <a (click)="logout()">
                                <i class="pi pi-power-off"></i>
                                <h6>Salir</h6>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>
